import { $getRoot, $isLineBreakNode, $isParagraphNode } from "lexical";
import { $isDynamicContentNode } from "../../nodes/dynamic-content/dynamic-content-node";
import { $isMergeTagV2Node } from "../../nodes/merge-tag-node-v2";
import { $isSurveyLinkNode } from "../../nodes/survey-link-node";
import { $findAllNodesOfType } from "../find-all-nodes-of-type";

import type { LexicalEditor, LexicalNode } from "lexical";

function getText(node: LexicalNode): string {
  if ($isDynamicContentNode(node)) {
    return `{{#if ${node.getCleanSegmentId()}}}${node.getTextContent()}{{/if}}`;
  }
  if ($isParagraphNode(node)) {
    return node.getChildren().map(getText).join("");
  }
  if ($isSurveyLinkNode(node)) {
    return node.__url;
  }
  if ($isLineBreakNode(node)) {
    return "\n";
  }
  return node.getTextContent();
}

export function transformTwilio(editor: LexicalEditor): { body: string; text: string } {
  // We need to manually update merge tags to be {{merge_tag}} instead of merge_tag
  const mergeTagNodes = editor
    .getEditorState()
    .read(() => $findAllNodesOfType($getRoot(), $isMergeTagV2Node));

  editor.update(
    () => {
      mergeTagNodes.forEach((node) => {
        node.setTextContent(`{{${node.getTextContent()}}}`);
      });
    },
    { discrete: true },
  );

  const body = editor.getEditorState().read(() => $getRoot().getChildren().map(getText).join("\n"));
  return { body, text: body };
}
